// Room types for Sri Sode Vadiraja Matha guest accommodation
export const ROOM_TYPES = [
  {
    id: "standard",
    name: "Standard Room",
    tagline: "Comfortable, essential amenities",
    price: 800,
    capacity: 2,
    amenities: ["Attached bathroom", "Cot with mattress", "Ceiling fan", "Drinking water", "Bed linen"],
    image:
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "deluxe",
    name: "Deluxe Room",
    tagline: "Spacious with additional comfort",
    price: 1500,
    capacity: 3,
    amenities: ["Attached bathroom with hot water", "Queen-size bed", "Air conditioning", "Study desk", "Complimentary tea/coffee"],
    image:
      "https://images.unsplash.com/photo-1631049035182-249067d7618e?auto=format&fit=crop&w=1200&q=70",
  },
  {
    id: "family",
    name: "Family Suite",
    tagline: "For families & small groups",
    price: 2500,
    capacity: 5,
    amenities: ["Two bedrooms", "Living area", "Attached bathroom (hot water)", "Air conditioning", "Refrigerator & tea maker"],
    image:
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1200&q=70",
  },
];

// Refundable deposit collected at the check-in counter, in INR
export const REFUNDABLE_DEPOSIT = 500;

// Deterministic mock inventory: how many rooms of each type exist per day.
// Availability is derived by subtracting bookings held in localStorage.
export const ROOM_INVENTORY = {
  standard: 8,
  deluxe: 4,
  family: 2,
};

export const BOOKING_RULES = [
  "Booking is for one day only (23 hours from check-in).",
  "No cancellation, refund, or date / time change is allowed after booking.",
  "Extension of stay is not permitted. Check-out time is strict.",
  "A maximum of two room bookings per user (email) per month.",
  "Booking window: 3 to 30 days in advance.",
  "A refundable deposit of ₹500 is payable at the check-in counter.",
  "Sri Sode Vadiraja Matha may cancel and refund bookings if required by policy.",
];
